import { AHCREvent } from 'domain/ahcr-event'

export interface AHCREventFilters {
  cameraNameFilter: string
  genderFilter: string
  hatFilter: string
  bagFilter: string
  maskFilter: string
  glassFilter: string
  thingsFilter: string
  ageGroupFilter: string
  hairStyleFilter: string
  jacketTypeFilter: string
  jacketColorFilter: string
  trousersTypeFilter: string
  trousersColorFilter: string
}

const match = (field: string | null | undefined, filter: string): boolean =>
  (field?.toLowerCase() ?? 'unknown') === filter

export const filterAHCREvent = (event: AHCREvent, filters: AHCREventFilters): boolean => {
  if (filters.cameraNameFilter && event.cameraName !== filters.cameraNameFilter) return false
  if (filters.genderFilter && !match(event.gender, filters.genderFilter)) return false
  if (filters.hatFilter && !match(event.hat, filters.hatFilter)) return false
  if (filters.bagFilter && !match(event.bag, filters.bagFilter)) return false
  if (filters.maskFilter && !match(event.mask, filters.maskFilter)) return false
  if (filters.glassFilter && !match(event.glass, filters.glassFilter)) return false
  if (filters.thingsFilter && !match(event.things, filters.thingsFilter)) return false
  if (filters.ageGroupFilter && !match(event.ageGroup, filters.ageGroupFilter)) return false
  if (filters.hairStyleFilter && !match(event.hairStyle, filters.hairStyleFilter)) return false
  if (filters.jacketTypeFilter && !match(event.jacketType, filters.jacketTypeFilter)) return false
  if (filters.jacketColorFilter && !match(event.jacketColor, filters.jacketColorFilter)) return false
  if (filters.trousersTypeFilter && !match(event.trousersType, filters.trousersTypeFilter)) return false
  if (filters.trousersColorFilter && !match(event.trousersColor, filters.trousersColorFilter)) return false
  return true
}
